<template>
  <div class="step likelyProductsList">
    <Heading :text="getResultsText" />
    <ListWrapper>
      <template>
        <div
          class="listItemResult"
          v-for="(product, key) in products"
          :style="[{ color: siteSettings.textColor }]"
          :key="key"
          @mouseover="hover(key)"
          @mouseout="endHover"
        >
          <div class="imageWrapper" v-if="product.image">
            <img class="answerImage" :src="product.image" />
          </div>
          <div class="content">
            <!-- <h3 v-html="product.name || ''"></h3> -->
            <!-- <div style="display:flex;flex-direction:column;"> -->
            <!-- <div
                style="line-height: 30px;display:flex;flex-direction:row;white-space:break-spaces;"
                :key="key"
                v-for="key in Object.keys(product.attributes || {})"
              >
                <p
                  style="font-size:18px;font-weight:bold;color:red; text-transform: uppercase;"
                >{{ key }}:</p>
                <p>{{ product.attributes[key] }}</p>
              </div> -->
            <h2
              class="likelyProductName"
              v-if="product.name"
              v-html="product.name"
            ></h2>
            <div class="tagsWrapper">
              <!-- icons for tags -->
              <div class="tag" v-for="(tag, idx) in product.tags" :key="idx">
                <img :src="tag.image" v-if="tag.image" :title="tag.name" />
                <!-- <span
                  v-else-if="tag.name"
                  :style="{
                    color: siteSettings.textColor,
                    background: siteSettings.accent
                  }"
                  >{{ tag.name }}
                </span> -->
              </div>
            </div>
            <div
              class="likelyProductDescriptionShort"
              v-if="product.description"
              v-html="product.description"
            ></div>
            <div
              class="cartButton"
            >
            <div style="display:inline-flex;" v-if="product.id && siteSettings.showAddToCart">
                <button
                  @click="addProductToCart(product.id)"
                  :disabled="disableUser"
                  v-if="!product.addedToCart && !addToCartFallBack"
                >
                  Add to cart
                </button>
                <a
                  :href="product.cartLink"
                  v-if="product.cartLink && addToCartFallBack"
                >
                  Add to cart
                </a>
                <span v-if="product.addedToCart">Added to cart </span>
            </div>
              <span
                class="price"
                v-if="siteSettings.showPrice"
                v-html="product.price"
              >
              </span>
            </div>
            <!-- </div> -->
          </div>
        </div>
        <Share v-if="isOwnerOfResults" />
        <button @click="resetAllAndScroll()" v-else>
          Make your own list!
        </button>
      </template>
    </ListWrapper>

    <Debug />
  </div>
</template>

<script>
import ListWrapper from "./ListWrapper.vue";
import Heading from "./Heading.vue";
import Share from "./Share.vue";

import Debug from "./Debug.vue";
import { mapMutations, mapState, mapActions, mapGetters } from "vuex";

import { scrollToElement } from "../assets/js/helper";

export default {
  name: "Answer",
  props: {
    products: {
      type: String,
      required: true
    }
  },
  components: {
    ListWrapper,
    Heading,
    Debug,
    Share
  },
  data() {
    return {
      active: null
    };
  },
  computed: {
    ...mapState([
      "siteSettings",
      "matrixArray",
      "userProductResults",
      "productAnswersArray",
      "siteSettings",
      "likeliestProductsList",
      "products",
      "imageFallBack",
      "disableUser",
      "addToCartFallBack",
      "isOwnerOfResults"
    ]),
    ...mapGetters(["getResultsText"])
  },
  methods: {
    scrollToElement() {
      if (!this.isOnFirstQuestion) {
        scrollToElement(this.$root.slider, {
          behavior: "smooth",
          block: "start"
        });
      }
    },
    resetAllAndScroll() {
      this.resetAll();
      setTimeout(() => {
        this.scrollToElement();
      }, 1500);
    },
    ...mapMutations(["setCurrentStep", "setShowSlidePostEnding", "resetAll"]),
    ...mapActions(["addProductToCart"]),
    reset() {
      this.setCurrentStep("1");
      this.setShowSlidePostEnding(false);
    },
    hover(key) {
      this.active = key;
    },
    endHover() {
      this.active = null;
    }
  }
};
</script>
<style>
p,
h3 {
  margin: 0;
}
</style>
<style lang="scss" scoped>
.step {
  width: inherit;
  height: inherit;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  // justify-content: center;
  .listWrapper {
    width: inherit;
    flex-direction: column;
    .listItemResult {
      text-align: left;
      display: flex;
      text-decoration: none;
      padding: 20px 0px;
      margin-bottom: 20px;
      border-bottom: 1px solid #ccc;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      width: inherit;
      @media only screen and (max-width: 900px) {
        flex-direction: column;
      }
      // .listItem
      //   text-align: center;
      //   min-width: 60%;
      //   width: inherit;
      //   background: white;
      //   margin: 10px;
      //   border: 2px solid white;
      //   cursor: pointer;
      //   box-shadow: inset 0 0 0 2px rgba(15, 78, 99, 0),
      //     2px 4px 7px rgba(0, 0, 0, 0.11);
      //   text-decoration: none;
      //   color: inherit;
      // img {
      //  width: 200px;
      //  height: 200px;
      // }
      .imageWrapper {
        display: block;
        flex: 0 0 261px;

        img {
          width: 100%;
        }
      }
      .content {
        padding: 10px 30px;
        margin-left: 20px;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @media only screen and (max-width: 900px) {
          padding: 0;
          margin-left: 0;
          font-size: 16px;
        }
        .likelyProductName {
          padding: 0;
          margin: 0;
          @media only screen and (max-width: 900px) {
            margin-top: 22px;
            font-size: 22px;
          }
        }
        .likelyProductDescriptionShort{
          font-size: 22px;
          @media only screen and (max-width: 900px) {
            font-size: 15px;
          }
        }
        .tagsWrapper {
          display: flex;
          flex-direction: row;
          max-width: 432px;
          flex-wrap: wrap;
          .tag {
            margin: 0 1px;
            img {
              width: 70px;
              height: 70px;
              max-width: 150px;
              transition: all 0.32s;
              border-radius: 50%;
              &:hover {
                transform: scale(1.1);
              }
              @media only screen and (max-width: 350px) {
                width: 60px;
                height: 60px;
              }
            }
            span {
              padding: 5px;
            }
          }
          @media only screen and (max-width: 900px) {
            max-width: 100%;
          }
        }
        .cartButton {
          margin: 5px 0 0;
          display: inline-flex;
          white-space: nowrap;
          align-items: center;

          a {
            padding: 10px;
            text-decoration: none;
            color: #fff;
            background-color: #08c;
            border: none;
            outline: none;
            cursor: pointer;
          }
          .price {
            margin-left: 20px;
            font-size: 24px;
            color: #0088cd;
          }
        }
      }
      h2 {
        margin: 18px;
      }
      // &:hover {
      //   border: 2px solid #0b6a6e;
      // }
    }
  }
  .arrowRight {
    height: 50px;
    cursor: pointer;
  }
  .notice {
    color: red;
  }
}
button {
  padding: 15px;
  text-decoration: none;
  color: #fff;
  background-color: #08c;
  border: none;
  outline: none;
  cursor: pointer;
  &:disabled {
    opacity: 0.5;
  }
}
.likelyProductsList h4 {
  font-size: 15px;
}
.likelyProductsList h2 {
  font-size: 25px;
}
.likelyProductsList h2 {
  font-size: 25px;
}

</style>
